// This file contains functions that are used in multiple components
// highgarden/services.js

export const getItemMeasure = (itemOrProduct) => {
    const getFromDetails = (details) => {
        if (!details) return null;
        // Preferred canonical shape used across the app
        if (details.measurement_type && details.measure && details.unit_of_measure) {
            return `${details.measure} ${details.unit_of_measure}`;
        }
        // Legacy shapes we still support
        if (details.weight && details.weight_measure) {
            return `${details.weight} ${details.weight_measure}`;
        } else if (details.volume && details.volume_measure) {
            return `${details.volume} ${details.volume_measure}`;
        } else if (details.units) {
            return `${details.units} units`;
        }
        return null;
    };

    if (!itemOrProduct) return "No specific measurements available";

    // If a full product object with `product_details` is passed
    if (itemOrProduct.product_details) {
        return getFromDetails(itemOrProduct.product_details) || "No specific measurements available";
    }

    // If an item wrapper with `linked_product` is passed
    if (itemOrProduct.linked_product) {
        const lp = itemOrProduct.linked_product;
        return getFromDetails(lp.product_details) || getFromDetails(lp) || "No specific measurements available";
    }

    // If a plain details/product-like object is passed
    return getFromDetails(itemOrProduct) || "No specific measurements available";
};


export const CATEGORY_ICON_CHOICES = [
    { slug: "fruits", icon: "bi bi-egg-fried" },
    { slug: "personal-care", icon: "bi-heart" },
    { slug: "plants", icon: "bi-flower1" },
    { slug: "vegetables", icon: "bi-basket" },
    { slug: "legumes", icon: "bi-bean" },
    { slug: "milk-dairy", icon: "bi-cup-straw" },
    { slug: "nuts", icon: "bi bi-disc" },
    { slug: "cooking-essentials", icon: "bi-egg-fried" },
    // Add more categories and icons as needed
];


export const getCategoryIcon = (slug) => {
    const category = CATEGORY_ICON_CHOICES.find(category => category.slug === slug);
    return category ? category.icon : "bi bi-patch-question"; // Default icon if slug is not found
};
